// extracted by mini-css-extract-plugin
module.exports =  {"menuBarRoot":"MenuBarV2-module__menuBarRoot--mSWQr","menuItem":"MenuBarV2-module__menuItem--WD0c0","menuItemSearch":"MenuBarV2-module__menuItemSearch--J1iSU"};